import { render, staticRenderFns } from "./FeedProductInformation.vue?vue&type=template&id=1e58d20e&"
import script from "./FeedProductInformation.vue?vue&type=script&lang=ts&"
export * from "./FeedProductInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports